import React, { useState, useEffect } from 'react';
import { GetAllSponsors, UpdateSponsor } from '../../Backend/ApiCalls';
import { useNavigate } from 'react-router-dom';
import { resolveSponsorImage, sponsorHasPromotion } from '../../utils/sponsorMedia';
import { getPromotionState } from './SponsorsListComponnet';
import './AdminSponsorComponent.css';

const AdminSponsorComponent = () => {
    const [sponsors, setSponsors] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        // Limpiar sessionStorage al entrar en este componente
        sessionStorage.removeItem('sponsorId');

        async function fetchSponsors() {
            try {
                const { data } = await GetAllSponsors();
                setSponsors(data);
                setLoading(false);
            } catch (error) {
                console.error('Error al obtener los patrocinadores:', error);
            }
        }
        fetchSponsors();
    }, []);

    const handleDeactivate = async (sponsor) => {
        const nextActive = sponsor.active === false;
        if (window.confirm(`¿Quieres ${nextActive ? 'activar' : 'desactivar'} este patrocinador?`)) {
            try {
                const { response, data } = await UpdateSponsor(sponsor.id, { active: nextActive });
                if (!response.ok) throw new Error(data?.error || 'No se pudo cambiar el estado');
                setSponsors((items) => items.map((item) => item.id === sponsor.id ? { ...item, active: nextActive } : item));
            } catch (error) {
                console.error('Error al desactivar descuento:', error);
            }
        }
    };

    const handleEdit = (id) => {
        sessionStorage.setItem('sponsorId', id);  // Guardar ID en sessionStorage
        navigate(`/admin/patrocinadores/editar/${id}`);
    };

    return (
        <div className="sponsors-admin-container">
            <div className="sponsors-admin-heading"><p>Administración</p><h1>Patrocinadores</h1></div>
            <button className="add-sponsor-btn" onClick={() => navigate('/admin/patrocinadores/nuevo')}>
                + Crear patrocinador
            </button>
            {loading ? (
                <p>Cargando patrocinadores...</p>
            ) : (
                <div className="sponsors-list">
                    {sponsors.map((sponsor) => {
                      const hasPromotion = sponsorHasPromotion(sponsor);
                      const state = getPromotionState(sponsor);
                      const logo = resolveSponsorImage(sponsor.logo);
                      return (
                        <article key={sponsor.id} className="sponsor-item">
                            <div className="sponsor-item-logo">{logo ? <img src={logo} alt={`Logo de ${sponsor.name}`} /> : <span>Sin logo</span>}</div>
                            <h2>{sponsor.name || 'Patrocinador sin nombre'}</h2>
                            <p className={`sponsor-company-state ${sponsor.active === false ? 'is-off' : ''}`}>{sponsor.active === false ? 'Patrocinador desactivado' : 'Patrocinador activo'}</p>
                            <div className="sponsor-admin-promotion"><strong>Promoción</strong><span>{hasPromotion ? sponsor.promotion : 'Sin promoción'}</span>{hasPromotion && <small>{state === 'active' ? 'Activa' : state === 'expired' ? 'Caducada' : state === 'upcoming' ? 'Próxima' : 'Desactivada'}</small>}</div>
                            <div className="sponsor-admin-actions">
                            <button className="edit-btn" onClick={() => handleEdit(sponsor.id)}>
                                Editar
                            </button>
                            <button className="view-btn" onClick={() => navigate('/patrocinadores')}>Ver</button>
                            <button className="delete-btn" onClick={() => handleDeactivate(sponsor)}>
                                {sponsor.active === false ? 'Activar' : 'Desactivar'}
                            </button>
                            </div>
                        </article>
                      );
                    })}
                </div>
            )}
        </div>
    );
};

export default AdminSponsorComponent;
